<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>账号登录</header>
    <main>
      <div :class="$style.accountWrap">
        <div :class="$style.inputWrap">
          <img :src="`${$cdnLink}/wanXin/orangeTheme/zhanghao.png`" alt :class="$style.leftIcon" />
          <input type="text" placeholder="请输入用户名" v-model.trim="form.username" />
          <img
            :src="`${$cdnLink}/wanXin/orangeTheme/xiala.png`"
            alt
            :class="$style.rightIcon"
            @click="showUserList"
          />
        </div>
        <transition name="slide">
          <ul :class="[$style.userList, accountListVisible && $style.active]" ref="userList">
            <div>
              <li v-for="(item, index) in userList" :key="index" @click="selectAccount(item)">
                <img :src="`${$cdnLink}/wanXin/orangeTheme/zhanghao1.png`" />
                <span>{{ item.username }}</span>
              </li>
            </div>
          </ul>
        </transition>
      </div>
      <div :class="[$style.inputWrap, $style.pwd]">
        <img :src="`${$cdnLink}/wanXin/orangeTheme/mima.png`" :class="$style.leftIcon" />
        <input type="password" placeholder="请输入密码" v-model.trim="form.password" />
        <img
          :src="`${$cdnLink}/wanXin/orangeTheme/shanchu.png`"
          :class="$style.rightIcon"
          @click="form.password = ''"
        />
      </div>
      <div :class="$style.redirect">
        <span @click="toReg">账号注册</span>
        <span @click="toForgetPawd">忘记密码？</span>
      </div>
      <button :class="$style.submitBtn" @click="handleLogin">登录</button>
      <div :class="$style.agree">
        <img
          @click="tocheck"
          :src="agreement ? `${$cdnLink}/wanXin/orangeTheme/xuanzhong.png` : `${$cdnLink}/wanXin/orangeTheme/weixuanzhong.png`"
          alt
        />
        <span>我已阅读并接受<span  @click="redirectArgument(0, 0)">《用户服务协议》</span>和<span @click="redirectArgument(1, 0)">《用户隐私协议》</span></span>
      </div>
    </main>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import { getAccount, setStorage } from '@/libs/utils'
import { regexpVerify } from '@/libs/business/account';
import isFullScreen from '@/libs/business/fullScreen';
import { mapState } from 'vuex';

export default {
  name: "",
  props: [
    "isClient"
  ],
  data() {
    return {
      fullScreen: '',
      accountListVisible: false,
      bs: null,
      userList: [],
      form: {},
      agreement: false, // 是否同意协议
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {
    this.scrollInit();
    if (!this.isClient) this.getUserList();
  },
  computed: {
    ...mapState({
      channel_status: state => state.user.channel_status
    })
  },
  watch: {
    channel_status(val) {
      const cache = localStorage.getItem('agreement_flag');
      if (val == 1) {
        this.agreement = false
      } else if (cache == '1') {
        this.agreement = true;
      }
    }
  },
  methods: {
    tocheck() {
      this.agreement = !this.agreement;
    },
    redirectArgument(type, source) {
      this.$emit("redirectArgument", type, source);
    },
    // 获取登录过的用户列表
    async getUserList() {
      this.userList = getAccount();
      if (this.userList && this.userList.length) this.form = this.userList[0];
    },
    showUserList() {
      this.accountListVisible = !this.accountListVisible;
      if (this.accountListVisible) {
        setTimeout(() => {
          this.bs && this.bs.refresh();
        }, 200);
      }
    },
    scrollInit() {
      this.bs = new BScroll(this.$refs.userList, {
        click: true,
        bounceTime: 300,
      });
    },
    selectAccount(item) {
      this.form = item
      this.accountListVisible = false;
    },

    toReg() {
      this.$emit('redirectRegist');
    },
    toForgetPawd() {
      this.$emit('redirectForget');
    },
    async handleLogin() {
      await regexpVerify(this.form, [
        { key: 'username', hint: '请输入正确的用户名' },
        { key: 'password', hint: '请输入正确的密码' }
      ]);
      if (!this.agreement) {
        this.$toast('请先同意用户服务协议');
        return;
      }
      localStorage.setItem('agreement_flag', 1);
      this.$emit('login', this.form);
    }
  },
};
</script>

<style lang="scss" module>
@import "../../assets/css/common.scss";

.wrap {
  @include common-window();
  > main {
    padding-top: 0.39rem;
    .accountWrap {
      position: relative;
    }
    .inputWrap {
      @include common-inputWrap();
      position: relative;
      z-index: 10;
      &.pwd {
        margin-top: 0.33rem;
        z-index: 1;
        > .leftIcon {
          width: 0.22rem;
        }
      }
    }
    .userList {
      position: absolute;
      top: 0.3rem;
      width: 4.44rem;
      left: 0;
      right: 0;
      margin: auto;
      height: 0;
      background: #f3f3f3;
      border-radius: 0 0 0.4rem 0.4rem;
      transition: height 200ms ease-in;
      perspective: 1000px;
      overflow: auto;
      z-index: 5;
      &.active {
        height: 2rem;
      }
      li {
        display: flex;
        padding: 0.15rem 0;
        margin: 0 0.3rem;
        align-items: center;
        border-bottom: 1px solid #dad9d9;
        @media screen and (-webkit-min-device-pixel-ratio: 2) {
          border-bottom: 0.5px solid #dad9d9;
        }
        @media screen and (-webkit-min-device-pixel-ratio: 3) {
          border-bottom: 0.333333px solid #dad9d9;
        }
        > img {
          width: 0.22rem;
        }
        > span {
          width: 3.5rem;
          padding-left: 0.1rem;
        }
      }
      li:nth-child(1) {
        padding-top: 0.65rem;
      }
    }
    .redirect {
      display: flex;
      color: $primary-color-1;
      justify-content: space-between;
      width: 4.44rem;
      margin: auto;
      font-size: $font-nm-1;
      > span {
        padding: 0.12rem 0.22rem 0.22rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .submitBtn {
      @include common-button();
    }
    .agree {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.2rem;
      color: #999999;
      margin-top: 0.16rem;
      > img {
        width: 0.17rem;
        height: 0.17rem;
        margin-right: 0.1rem;
        margin-top: 0.02rem;
      }
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > main {
      padding-top: 19px;
      .accountWrap {
        position: relative;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        position: relative;
        z-index: 10;
        &.pwd {
          margin-top: 16px;
          z-index: 1;
          > .leftIcon {
            width: 11px;
          }
        }
      }
      .userList {
        position: absolute;
        top: 15px;
        width: 222px;
        left: 0;
        right: 0;
        margin: auto;
        height: 0;
        background: #f3f3f3;
        border-radius: 0 0 20px 20px;
        transition: height 200ms ease-in;
        perspective: 1000px;
        overflow: auto;
        z-index: 5;
        &.active {
          height: 100px;
        }
        li {
          display: flex;
          padding: 7px 0;
          margin: 0 15px;
          align-items: center;
          border-bottom: 1px solid #dad9d9;
          @media screen and (-webkit-min-device-pixel-ratio: 2) {
            border-bottom: 0.5px solid #dad9d9;
          }
          @media screen and (-webkit-min-device-pixel-ratio: 3) {
            border-bottom: 0.333333px solid #dad9d9;
          }
          > img {
            width: 11px;
          }
          > span {
            width: 175px;
            padding-left: 5px;
          }
          .del {
            // background-color: #000000;
            width: 32px;
            padding: 0 5px 0 15px;
          }
        }
        li:nth-child(1) {
          padding-top: 32px;
        }
      }
      .redirect {
        display: flex;
        color: $primary-color-1;
        justify-content: space-between;
        width: 222px;
        margin: auto;
        font-size: $font-nm;
        > span {
          padding: 6px 11px 11px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
      .agree {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        color: #999999;
        margin-top: 8px;
        > img {
          width: 8px;
          height: 8px;
          margin-right: 5px;
          margin-top: 1px;
        }
      }
    }
  }
}
</style>